export default __webpack_public_path__ + "static/media/coupang-no-text.a88f626e.webp";